import styled from '@emotion/styled';

import { spacing, borderRadius, colors, shadows } from '../tokens';

export type PanelPadding = 'none' | 'sm' | 'md' | 'lg';

const paddingMap: Record<PanelPadding, string> = {
  none: '0',
  sm: spacing.md, // 12px
  md: spacing.lg, // 16px
  lg: spacing['2xl'], // 24px
};

/**
 * Superfície branca arredondada que agrupa o conteúdo de uma seção (o "card
 * branco"). Genérica: só fornece fundo, raio, sombra e padding; o conteúdo é
 * livre (children).
 */
export const StyledPanel = styled('div', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<{ $padding: PanelPadding; $bordered: boolean; $shadow: boolean }>`
  box-sizing: border-box;
  width: 100%;
  background-color: ${colors.background};
  border-radius: ${borderRadius.lg};
  box-shadow: ${({ $shadow }) => ($shadow ? shadows.sm : 'none')};
  padding: ${({ $padding }) => paddingMap[$padding]};
  border: ${({ $bordered }) =>
    $bordered ? `1px solid ${colors.border}` : 'none'};
`;
